export default __webpack_public_path__ + "static/media/sampleDog3.3c9f4ad1.jpg";